export default __webpack_public_path__ + "static/media/aaa5be5cebf703b0.8ee3002a98e56809a211dbb22b60b3ed.svg";